var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "language-dropdown flex-center" },
    [
      _c("span", {
        staticClass: "flag-icon flag-icon-large",
        class: _vm.flagIconClass(_vm.currentLanguage()),
      }),
      _c(
        "vuestic-dropdown",
        {
          staticClass: "language-dropdown__container",
          attrs: { position: "bottom" },
          model: {
            value: _vm.isShown,
            callback: function ($$v) {
              _vm.isShown = $$v
            },
            expression: "isShown",
          },
        },
        _vm._l(_vm.options, function (option, id) {
          return _c(
            "a",
            {
              key: id,
              staticClass: "dropdown-item",
              class: { active: option.code === _vm.currentLanguage() },
              on: {
                click: function ($event) {
                  return _vm.setLanguage(option.code)
                },
              },
            },
            [
              _c("span", {
                staticClass: "flag-icon flag-icon-small",
                class: _vm.flagIconClass(option.code),
              }),
              _c("span", { staticClass: "dropdown-item__text ellipsis" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm._f("translate")(`language.${option.name}`)) +
                    "\n      "
                ),
              ]),
            ]
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }